module.exports = __webpack_public_path__ + "img/galardon.e5069fd4.png";